import ResourceList from "components/cms/ResourceList";
import useResourceList from "hooks/useResourceList";
import { deleteNewsletterIssue, listNewsletterIssues } from "api/newsletterissue";
import { enText } from "utils/cms";

export default function NewsletterIssuesPage() {
  const list = useResourceList({
    list: listNewsletterIssues,
    remove: deleteNewsletterIssue,
    confirm: (item) =>
      `Delete issue “${enText(item.title) || item.slug}”? This cannot be undone.`,
  });

  return (
    <ResourceList
      title="Newsletter issues"
      description="Issues use one shared template on /resources/newsletter"
      createHref="/admin/newsletter-issues/new"
      createLabel="New issue"
      emptyText="No issues yet. Create one to show it on /resources/newsletter."
      items={list.items}
      total={list.total}
      loading={list.loading}
      error={list.error}
      toast={list.toast}
      onCloseToast={() => list.setToast(null)}
      deletingId={list.deletingId}
      onDelete={list.onDelete}
      editHref={(item) => `/admin/newsletter-issues/${item._id}`}
      columns={[
        { key: "number", label: "Issue", render: (item) => item.number || "—" },
        { key: "title", label: "Title", render: (item) => enText(item.title) || "—" },
        { key: "slug", label: "Slug" },
        { key: "publishedAt", label: "Published" },
      ]}
    />
  );
}
